import {Component, HostBinding, Input, OnInit, forwardRef} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {animate, style, transition, trigger} from '@angular/animations';


@Component({
    selector: 'app-labeled-select-distributor-input',
    templateUrl: './labeled-select-distributor-input.component.html',
    styleUrls: ['./labeled-select-distributor-input.component.scss'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => LabeledSelectDistributorInputComponent),
        multi: true
    }],
    animations: [
        trigger('open', [
            transition(':enter', [
                style({marginTop: '-32px'}),
                animate('100ms', style({marginTop: '0'}))
            ])
        ])
    ]
})

export class LabeledSelectDistributorInputComponent implements ControlValueAccessor, OnInit {

    @Input()
    public label: string;
    @Input()
    public placeholder: string;

    @Input()
    public name: string;

    @Input()
    public id: string;

    @Input()
    public showValidation: boolean;
    @Input()
    public isError: boolean;

    @HostBinding('class.force-form-validation-visibility')
    @Input()
    forceFormValidationVisibility = false;

    @Input()
    public disabled: boolean;

    @Input()
    public choices: { label: string, labelClass: string, itemClass?: string, id?: number }[] = [];  // what is displayed


    @Input()
    public values: any[];

    public isExpanded = false;
    public model = -1;

    public isIEMode = false;

    public propagateChangeFn: (_: any) => void = (_: any) => {
        // tslint:disable-next-line
    };
    public onTouchedFn: () => void = () => {
        // tslint:disable-next-line
    };


    public writeValue(value: string | number): void {
        // console.log('value', value);


        if (this.values) {
            this.model = this.values.findIndex(v => v === value);
        } else {
            this.model = this.choices.findIndex(v => v.label === value);
        }
        // console.log('this.model', this.model);
        // console.log('this.choices[this.model]', this.choices[this.model]);
    }

    public registerOnChange(fn: any): void {
        this.propagateChangeFn = fn;
    }

    public registerOnTouched(fn: any): void {
        this.onTouchedFn = fn;
    }

    public togglePanel(): void {
        this.isExpanded = this.isIEMode ? true : !this.isExpanded;
    }

    public closePanel(buttonElement: HTMLElement): void {
        if (this.isIEMode) {
            buttonElement.focus();
        }
        this.isExpanded = false;
    }

    public mouseLeave() {
        this.isExpanded = false;
    }

    public onChoiceSelected(index: number) {
        this.model = index;
        this.updateChanges();
    }

    public updateChanges(): void {

        if (this.values) {
            this.propagateChangeFn(this.values[this.model]);
        } else {
            this.propagateChangeFn(this.choices[this.model]);
        }

    }

    public isChoiceSelected(index: number): boolean {
        return index === this.model;
    }

    public setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    public onBlur() {
        this.onTouchedFn();
        if (!this.isIEMode) {
            window.removeEventListener('keydown', this.preventDefaultForScrollKeys, false);
            this.isExpanded = false;
        }

    }

    public onKeyPressed($event: KeyboardEvent) {
        // console.log($event);
        if (!this.isIEMode) {  // currently the keys are not supported in IE
            window.addEventListener('keydown', this.preventDefaultForScrollKeys, false);

            if ($event.key === 'ArrowDown') {
                this.model += 1;
                if (this.choices.length - 1 < this.model) {
                    this.model = 0;
                }
            }

            if ($event.key === 'ArrowUp') {
                this.model -= 1;
                if (this.model < 0) {
                    this.model = this.choices.length - 1;
                }

            }
            this.updateChanges();
        }
    }

    public preventDefaultForScrollKeys(e) {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            e.preventDefault();
            return false;
        }
        return true;
    }

    ngOnInit(): void {
        const agent = window.navigator.userAgent.toLowerCase();
        this.isIEMode = agent.indexOf('trident') > -1;
    }

    getChoiceItemClass(i: number) {
        let result = {'selected-choice': this.isChoiceSelected(i)};
        if (this.choices[i].itemClass) {
            result = {...result, [this.choices[i].itemClass]: true};
        }
        return result;
    }
}
